import React from 'react'
import { Link } from 'react-router-dom'
import { Content } from '../../../../_myb/layout/components/content'
import { CustomLoader } from '../../utils/CustomLoader'
// import './RestrictedPage.css'  // Optional: Include a CSS file for custom styles

const LoadingPage: React.FC = () => {
  return (
    <Content>
      <CustomLoader />
    </Content>
  )
}

export default LoadingPage
